import { Link, Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./OIDCSignInLink.styles";

interface Props {
  onClick: () => void;
}

const OIDCSignInLink = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body" isMarginless customCss={styles.promptText}>
        {t(l.oauthSignUp.signInPrompt)}
      </Typography>
      <Link onClick={onClick}>{t(l.oauthSignUp.signInLink)}</Link>
    </>
  );
};

export { OIDCSignInLink };
